import React from 'react';
import styled from 'styled-components';

import AutoPayExpirationSVG from '../../../assets/autopay-expiration.svg';
import AutoPayIconSVG from '../../../assets/autopay-icon.svg';
import { MOBILE_BREAKPOINT, CARD_BREAKPOINT } from 'src/commons/constants';

const AutoPayIconContainer = styled.div`
  margin: 2.875rem 0 1.125rem;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 2.875rem 0 1rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 2.0625rem 0 0.875rem;
  }
`;
AutoPayIconContainer.displayName = 'AutoPayIconContainer';

const AutoPayIconImage = styled(AutoPayIconSVG)`
  width: 2.125rem;
  height: auto;
`;
AutoPayIconImage.displayName = 'AutoPayIconImage';

const AutoPayExpirationIconContainer = styled.div`
  margin: 3.5rem 0 1.125rem;
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 3.5rem 0 1rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 2.6875rem 0 0.875rem;
  }
`;
AutoPayExpirationIconContainer.displayName = 'AutoPayExpirationIconContainer';

const AutoPayExpirationImage = styled(AutoPayExpirationSVG)`
  width: 7.5rem;
  height: auto;
  margin-right: 1rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 6rem;
  }
`;

export const AutoPayIcon = () => (
  <AutoPayIconContainer>
    <AutoPayIconImage data-testid="autopay-icon" />
  </AutoPayIconContainer>
);

export const AutoPayExpirationIcon = () => (
  <AutoPayExpirationIconContainer>
    <AutoPayExpirationImage data-testid="autopay-expiration-icon" />
  </AutoPayExpirationIconContainer>
);
